import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IResetPasswordParams {
  resetToken: string;
  newEncryptedPassword: string;
  encryptionKeyId: string;
}

export class ResetPasswordRequest extends Request<IResetPasswordParams, IResult> {
  constructor(params: IResetPasswordParams) {
    super('resetPassword', params);
  }
}
